<template>
  <div class="flex flex-col space-y-4">
    <div class="flex flex-col justify-center items-center">
      <section class="mt-8 w-full lg:w-1/2">
        <h1 class="text-black font-clever text-5xl leading-none text-center">
          {{ header }}
        </h1>
        <p v-if="creators.length > 1" class="text-md py-4 px-4 lg:px-12 text-center">
          {{ description }}
        </p>
      </section>
    </div>

    <div class="px-4">
      <div v-if="creators.length === 1" class="flex justify-center items-center">
        <div class="flex justify-center items-center">
          <div>
            <a :href="'/creator-of-the-month#' + creators[0].id">
              <img style="height: 20rem" class="w-full object-cover" :src="creators[0].image" loading="lazy" />
            </a>
            <div
              class="leading-normal text-md bg-coral h-12 flex flex-col items-center justify-center text-primary font-semibold"
            >
              <p>{{ creators[0].name }}</p>
            </div>
          </div>
          <p class="text-md w-[30%] mx-4 text-center">
            {{ description }}
          </p>
        </div>
      </div>
      <carousel v-else :per-page="2" :per-page-custom="[[1024, 4]]">
        <slide v-for="creator in creators" :key="creator.id">
          <div class="px-1 flex flex-row justify-center">
            <div>
              <a :href="'/creator-of-the-month#' + creator.id">
                <img style="height: 20rem" class="w-full object-cover" :src="creator.image" loading="lazy" />
              </a>
              <div
                class="leading-normal text-md bg-coral h-12 flex flex-col items-center justify-center text-primary font-semibold"
              >
                <p>{{ creator.name }}</p>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>

    <div class="flex justify-center">
      <a href="/creator-of-the-month">
        <button class="block mt-8 button button-dark button-lg">get to know them</button>
      </a>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import pluralize from 'pluralize';

export default {
  components: {
    Carousel,
    Slide,
  },
  props: ['creators'],
  data() {
    return {
      description: `No one tells the story of Adore Me better than our Creators community. Every month we’ll feature an interview
          and content from some of our most beloved Creators to help you learn more about what makes them successful and
          what inspires them.`,
    };
  },
  computed: {
    header() {
      return `${pluralize('Creator', this.creators.length)} of the Month`;
    },
  },
};
</script>
